import conCreateDataset from './baseIcons/conc/conCreateDataset';
import conDatabase from './baseIcons/conc/conDatabase';
import conDatabasePlus from './baseIcons/conc/conDatabasePlus';
import conDataset from './baseIcons/conc/conDataset';
import conFolderPlus from './baseIcons/conc/conFolderPlus';
import conInsightSearchAlt from './baseIcons/conc/conInsightSearchAlt';
import conLNGBunkering from './baseIcons/conc/conLNGBunkering';
import conMachineLearning from './baseIcons/conc/conMachineLearning';
import conReport from './baseIcons/conc/conReport';
import conReport1 from './baseIcons/conc/conReport1';
import conSensorAlt from './baseIcons/conc/conSensorAlt';
import conSensorPlus from './baseIcons/conc/conSensorPlus';
import conUploadFile from './baseIcons/conc/conUploadFile';
import conUploadFile1 from './baseIcons/conc/conUploadFile1';
import cuiCheckboxIndeterminate from './baseIcons/cui/cuiCheckboxIndeterminate';
import cuiCheckboxSelected from './baseIcons/cui/cuiCheckboxSelected';
import cuiCheckboxUnselected from './baseIcons/cui/cuiCheckboxUnselected';
import cuiRadioSelected from './baseIcons/cui/cuiRadioSelected';
import cuiRadioUnselected from './baseIcons/cui/cuiRadioUnselected';
import culEyeAssess from './baseIcons/cul/culEyeAssess';
import fadSpinnerThird from './baseIcons/fad/fadSpinnerThird';
import falCheck from './baseIcons/fal/falCheck';
import falCheckCircle from './baseIcons/fal/falCheckCircle';
import falEllipsisH from './baseIcons/fal/falEllipsisH';
import falEllipsisV from './baseIcons/fal/falEllipsisV';
import falExclamationCircle from './baseIcons/fal/falExclamationCircle';
import falExclamationTriangle from './baseIcons/fal/falExclamationTriangle';
import falInfoCircle from './baseIcons/fal/falInfoCircle';
import falPlus from './baseIcons/fal/falPlus';
import falSpinner from './baseIcons/fal/falSpinner';
import falTimes from './baseIcons/fal/falTimes';
import falTimesCircle from './baseIcons/fal/falTimesCircle';
/**
 * Default icons are fundamental to functioning of certain components.
 * They are added to the icon library in order to avoid loading them from CDN.
 */
export const defaultIcons = {
    conCreateDataset,
    conDatabase,
    conDatabasePlus,
    conDataset,
    conFolderPlus,
    conLNGBunkering,
    conReport,
    conReport1,
    conSensorAlt,
    conSensorPlus,
    conUploadFile,
    conUploadFile1,
    conInsightSearchAlt,
    conMachineLearning,
    cuiCheckboxIndeterminate,
    cuiCheckboxSelected,
    cuiCheckboxUnselected,
    cuiRadioSelected,
    cuiRadioUnselected,
    culEyeAssess,
    fadSpinnerThird,
    falCheck,
    falCheckCircle,
    falEllipsisH,
    falEllipsisV,
    falExclamationCircle,
    falExclamationTriangle,
    falInfoCircle,
    falPlus,
    falSpinner,
    falTimes,
    falTimesCircle
};
